import { FeatureFlag, FeatureFlagValue } from '../../../hooks/FeatureFlag';
import { usePrerenderUserFeatures } from '../../../hooks/usePrerenderUser';

type AiInsightsAccessUser = {
  featureFlags: FeatureFlagValue[];
};

// Single source of truth for who can see AI Insights (sidebar entry,
// /ai-insights routes, report/export pages): every user, unless the tenant
// carries the `ai-insights-block` kill switch — a blocked tenant sees the
// feature as if it did not exist, @prerender.io staff included. rest-api
// enforces the same rule (AiInsightsAccessGuard).
export function hasAiInsightsAccess({ featureFlags }: AiInsightsAccessUser): boolean {
  return !featureFlags.includes(FeatureFlag.AiInsightsBlock);
}

export function useHasAiInsightsAccess(): boolean {
  const featureFlags = usePrerenderUserFeatures();
  return hasAiInsightsAccess({ featureFlags });
}
